// extracted by mini-css-extract-plugin
export var container = "_5c-0";